// src/utils/timerPersistence.js

const STORAGE_KEY = 'expertime_timer_state';


/*
 * =========================================================
 * GUARDAR ESTADO DEL TIMER
 * =========================================================
 */
export const saveTimerState = (state) => {

  try {

    const payload = {

      savedAt:
        Date.now(),

      reducerTimer:
        state.reducerTimer,

      reducerRegisterTime:
        state.reducerRegisterTime,

      reducerRegisterInfo:
        state.reducerRegisterInfo
    };


    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(payload)
    );

  } catch (error) {

    console.error(
      'Error guardando estado local del Timer:',
      error
    );
  }
};


/*
 * =========================================================
 * RECUPERAR ESTADO DEL TIMER
 * =========================================================
 */
export const loadTimerState = () => {

  try {

    const raw =
      localStorage.getItem(
        STORAGE_KEY
      );


    if (!raw) {

      return null;
    }


    return JSON.parse(raw);

  } catch (error) {

    console.error(
      'Error recuperando estado local del Timer:',
      error
    );


    return null;
  }
};


/*
 * =========================================================
 * ELIMINAR ESTADO LOCAL
 * =========================================================
 *
 * Se utiliza principalmente al hacer RESET.
 */
export const clearTimerState = () => {

  try {

    localStorage.removeItem(
      STORAGE_KEY
    );

  } catch (error) {

    console.error(
      'Error limpiando estado local del Timer:',
      error
    );
  }
};



// WEBPACK FOOTER //
// ./src/utils/timerPersistence.js